export { default as useColors } from "./useColors";
